import * as React from 'react';
import { ThemeContext } from 'styled-components';
import camelCase from 'lodash/camelCase';

import { Box } from '../../../Layout/Box';
import { IInputRadioField } from '../common';
import { useFocusControl } from '../../../Utils';
import { useFieldSetGroupContext } from '../../FieldSet/FieldSetGroup';

import { RadioBadgeInput, RadioBadgeLabel, RadioLabelSpan } from './RadioBadgeStyles';

// exporting here is a work around for this issue https://github.com/microsoft/tslint-microsoft-contrib/issues/667
export const InputRadioBadgeField =
  React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement> & IInputRadioField>((
  {
    children,
    groupName: groupNameComponent,
    hasError: hasErrorComponent,
    inputProps,
    value,
  },
  ref,
) => {
  const { themeTwo: { form: { radio: { badge }}}} = React.useContext(ThemeContext);
  const { clickFocus, stopClickFocus, resetClickFocus } = useFocusControl();
  const { errorIds, groupName, hasError, helperTextId } = useFieldSetGroupContext();

  const inputId: string = camelCase(`${groupName || groupNameComponent} ${value} id`);
  const RadioBadge = Box;
  const hasElevation: boolean = !!(!hasError && badge.shadow && inputProps && !inputProps.disabled);

  return (
    <RadioBadge
      boxShadow={hasElevation ? badge.shadow as string : undefined}
      borderRadius={badge.round && badge.round}
    >
      <RadioBadgeInput
        {...inputProps}
        aria-describedby={errorIds ? `${errorIds} ${helperTextId && helperTextId}` : helperTextId}
        id={inputId}
        name={groupName || groupNameComponent}
        ref={ref}
        type='radio'
        value={value}
        onBlur={resetClickFocus}
        error={hasError || hasErrorComponent}
        clickFocus={clickFocus}
      />
      <RadioBadgeLabel htmlFor={inputId} onMouseDown={stopClickFocus}>
        <RadioLabelSpan>{children}</RadioLabelSpan>
      </RadioBadgeLabel>
    </RadioBadge>
  );
});

export default InputRadioBadgeField;
